import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { StoreType } from '../../../types/product'
import { productApis } from '../../../gateways/breadstack/productApis'
import { productDetailQueryKey } from './useProduct'

export const useProductPosSync = (storeId: string, storeType: StoreType) => {
  const queryClient = useQueryClient()
  const mutation = useMutation({
    mutationFn: (productId: string) => productApis.syncFromPos(storeId, storeType, productId),
    onSuccess: (_result, productId) => {
      queryClient.invalidateQueries({ queryKey: productDetailQueryKey(storeId, productId) })
      queryClient.invalidateQueries({ queryKey: ['variationGroup', storeId, storeType, productId] })
    },
  })

  return {
    syncFromPos: mutation.mutate,
    isSyncing: mutation.isPending,
  }
}
